import React, { Component } from 'react';
import { inject, observer } from "mobx-react/index";
import DownloadPopUp from '../../../assets/images/download-dark.png';

@inject("store")
@observer
export default class DownloadPopupIcone extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <img src={DownloadPopUp} alt="download-pop-up" className={`popup-open-dark-icone ${this.props.className || ""}`} />;
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/DownloadDarkIcone.js